import { render, staticRenderFns } from "./accessible_panel_resizer.vue?vue&type=template&id=b53e3350"
import script from "./accessible_panel_resizer.vue?vue&type=script&lang=js"
export * from "./accessible_panel_resizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports